import { LiveStreamErrorCode } from './LiveStreamErrorCode';
export class NoHybridCapableProducerFoundForLocationError {
    constructor() {
        this.code = LiveStreamErrorCode.NoHybridCapableProducerFoundForLocation;
        this.message = 'No RealTime Recorder was found for this location.';
        this.name = LiveStreamErrorCode.NoHybridCapableProducerFoundForLocation;
    }
}
